import {Action, combineReducers, configureStore, ThunkAction,} from "@reduxjs/toolkit";
import {persistReducer, persistStore} from "redux-persist";
import localForage from "localforage";

import applicationReducer from "../screens/app/appSlice";
import objectReducer from "../screens/object/objectSlice";
import relatedRecordsReducer from "../screens/object/relatedRecordsSlice";
import combinedRelatedRecordsReducer from "../screens/object/combinedRelatedRecordsSlice";
import recordReducer from "../screens/record/recordSlice";
import celebrationsReducer from "../screens/celebrations/celebrationsSlice";
import globalLayoutReducer from "./globalLayoutSlice";

const persistConfig = {
  key: "store",
  storage: localForage,
  version: 1,
  // migrate: createMigrate(migrations, { debug: false }),
  //blacklist: ["notificationStore"],
  whitelist: [],
};

const rootReducer = combineReducers({
  applicationStore: applicationReducer,
  objectStore: objectReducer,
  recordStore: recordReducer,
  relatedRecordsStore: relatedRecordsReducer,
  combinedRelatedRecordsStore: combinedRelatedRecordsReducer,
  globalLayoutStore: globalLayoutReducer,
  celebrationsStore: celebrationsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
